import { Box, Flex, Image, useMediaQuery } from "@chakra-ui/react";
import React from "react";

import bg from "../../assets/meetings-bg.svg";
import MeetingParticipants from "./MeetingParticipants";
import MeetingControls from "./MeetingControls";
import JoinMeetingPopup from "./JoinMeetingPopup";
import { MeetingAttendeesList } from "./MeetingAttendeesList";
import { BsArrowsFullscreen } from "react-icons/bs";
import { useState } from "react";
import MeetingMessaging from "./meetingMessaging/MeetingMessaging";
import MobileBottomNavigation from "./MobileBottomNavigation";
import FloatingParticipants from "./FloatingParticipants";
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";

export const fullScreenStyles = {
  position: "fixed",
  top: "0",
  bottom: "0",
  left: "0",
  right: "0",
  w: "100%",
  h: "100%",
  zIndex: "1999",
};

export const fullScreenControlStyles = {
  position: "absolute",
  bottom: "10px",
  px: "30px",
};
function GroupMeeting() {
  const [fullScreen, setFullScreen] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [showFloatingParticipants, setShowFloatingParticipants] =
    useState(false);

  return (
    <MobileBottomNavigation>
      <Box w={["100%", "73%"]}>
        <MeetingParticipants />
        <Flex
          width="100%"
          flexDirection={"column"}
          justifyContent={"space-between"}
          {...(fullScreen ? fullScreenStyles : {})}
        >
          <Box
            width="100%"
            height={fullScreen ? "100%" : "430px"}
            borderRadius="10px"
            overflow={"hidden"}
            position={"relative"}
            boxShadow="lg"
          >
            <JoinMeetingPopup />
            <Image
              position={"absolute"}
              w="100%"
              h="100%"
              src={bg}
              alt="meeting"
              objectFit={"cover"}
            />
            <MeetingMessaging
              showMessaging={showChat}
              setShowMessaging={setShowChat}
              position="absolute"
              top="23%"
              left="10px"
            />

            <FloatingParticipants
              showParticipants={showFloatingParticipants}
              setShowParticipants={(data) => {
                console.log(data);
                setShowFloatingParticipants(data);
              }}
              w="300px"
              h="350px"
              position="absolute"
              top="23%"
              left="10px"
            />

            <Flex
              w="40px"
              h="40px"
              position={"absolute"}
              justifyContent="center"
              alignItems="center"
              borderRadius={"50%"}
              right="10px"
              onClick={() => setFullScreen((prev) => !prev)}
              cursor="pointer"
            >
              {fullScreen ? (
                <AiOutlineFullscreenExit color="#FAFBFC" fontSize={"1.6em"} />
              ) : (
                <AiOutlineFullscreen color="#FAFBFC" fontSize={"1.6em"} />
              )}
            </Flex>
          </Box>
          <MeetingControls
            {...(fullScreen ? fullScreenControlStyles : {})}
            fullScreen={fullScreen}
            setShowChat={setShowChat}
            setShowFloatingParticipants={setShowFloatingParticipants}
          />
        </Flex>
      </Box>
      <MeetingAttendeesList
        w={["100%", "25%", "25%"]}
        list={[1, 2, 4, 3, 5, 6, 7, 8, 9, 0, 12, 3, 4, 5, 6, 7, 8, 9]}
      />
    </MobileBottomNavigation>
  );
}

export default GroupMeeting;
